import { get, put } from './utils';

const provider = {
  getParameters: (resource) => get(resource),

  updateParameters: (resource, data) => put(resource, data),
};

export default provider;
